import { useSelector } from 'react-redux';
import { Store } from 'components/common/types/Store.types';
import Overlay from 'lib/Overlay';
import { thoughtspot } from 'config';
import LiveboardVisuals from 'components/common/LiveboardVisuals';
import { getIsReseller } from 'store/publisher/selectors';
import {
  filterByCampaignOwner,
  labsReportVisibleActions,
  filterByAssetOwner,
  thoughtspotLiveboardStyles,
  hiddenAssetOwnerThoughtspotLiveboardStyles,
} from '../utils';
import { getUpdateParametersForTimeRange, getUpdateParametersForTimezone } from '../../utils';
import { LabsLiveboardProps } from '../LabsLiveboard.types';

export const DealHealthChinaLiveboard: React.FC<LabsLiveboardProps> = ({ showLiveboard, onHideLiveboard }) => {
  const { marketId, timezone, timezoneOverride } = useSelector((state: Store) => state.publisher.configuration);
  const isReseller = useSelector(getIsReseller);

  const dealHealthLiveboardId = isReseller ? thoughtspot.chinaDealHealthLiveboardId : thoughtspot.dealHealthDashboardId;

  const today = new Date();
  const liveboardUpdateParameters = [
    ...getUpdateParametersForTimezone(timezoneOverride ?? timezone),
    ...getUpdateParametersForTimeRange({ startDate: today, endDate: today }),
  ];

  if (!showLiveboard) return null;
  return (
    <Overlay
      onClose={onHideLiveboard}
      isOpen={showLiveboard}
      childrenExtraStyles="flex"
      header={
        <header>
          <h3 className="sub-header-lg text-neutral-900">Deal Health</h3>
        </header>
      }
    >
      <LiveboardVisuals
        liveboardId={dealHealthLiveboardId}
        customizations={isReseller ? thoughtspotLiveboardStyles : hiddenAssetOwnerThoughtspotLiveboardStyles}
        visibleActions={labsReportVisibleActions}
        filterByOptions={[isReseller ? filterByCampaignOwner(marketId) : filterByAssetOwner(marketId)]}
        updateLiveboardParameters={liveboardUpdateParameters}
      />
    </Overlay>
  );
};
